var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useLazyQuery } from '@apollo/client';
import CircleIcon from '@mui/icons-material/Circle';
import { Tooltip, useMediaQuery, useTheme } from '@mui/material';
import { ActivityValidationLevels } from 'common/enums/activity/activity-validation-levels.enum';
import { ACTIVITY_VALIDATION_SPORT_EVENT } from 'common/graphql/queries/activity-validations/activity-validation-sport-event';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import HelperFunctions from 'utils/HelperFunctions';
var ValidationStatusTooltip = function (_a) {
    var validationId = _a.validationId, validationLevel = _a.validationLevel, text = _a.text, color = _a.color, isShowSeeDetailsText = _a.isShowSeeDetailsText;
    var t = useTranslation().t;
    var _b = useState(text), tooltipTitle = _b[0], setTooltipTitle = _b[1];
    var _c = useState(false), openValidationStatusTooltip = _c[0], setOpenValidationStatusTooltip = _c[1];
    var _d = useLazyQuery(ACTIVITY_VALIDATION_SPORT_EVENT), getValidationSportEvent = _d[0], data = _d[1].data;
    useEffect(function () {
        if (validationLevel === ActivityValidationLevels.SportEvent && validationId) {
            getValidationSportEvent({
                variables: {
                    id: validationId
                }
            });
        }
    }, [validationLevel]);
    useEffect(function () {
        var _a, _b, _c, _d, _e, _f;
        if ((_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.activityValidation) === null || _a === void 0 ? void 0 : _a.sportEvent) === null || _b === void 0 ? void 0 : _b.mainSettings) === null || _c === void 0 ? void 0 : _c.displayName) {
            setTooltipTitle(tooltipTitle +
                '. ' +
                t('Событие') +
                ': ' +
                ((_f = (_e = (_d = data === null || data === void 0 ? void 0 : data.activityValidation) === null || _d === void 0 ? void 0 : _d.sportEvent) === null || _e === void 0 ? void 0 : _e.mainSettings) === null || _f === void 0 ? void 0 : _f.displayName));
        }
    }, [data]);
    var title = isShowSeeDetailsText ? tooltipTitle + '. ' + t('Подробности на странице тренировки.') : tooltipTitle;
    return (_jsx(Tooltip, __assign({ onMouseOver: function () { return setOpenValidationStatusTooltip(true); }, onMouseLeave: function () { return setOpenValidationStatusTooltip(false); }, onClose: function () { return setOpenValidationStatusTooltip(false); }, open: openValidationStatusTooltip, title: title, leaveTouchDelay: 10000, leaveDelay: 700 }, { children: _jsx(CircleIcon, { style: { fontSize: '14' }, sx: { color: color } }, void 0) }), void 0));
};
var ValidationStatus = function (_a) {
    var validations = _a.validations, isShowTapText = _a.isShowTapText, isShowSeeDetailsText = _a.isShowSeeDetailsText;
    var t = useTranslation().t;
    var theme = useTheme();
    var isMobile = useMediaQuery(theme.breakpoints.down('md'));
    var getState = HelperFunctions.getValidationState;
    var filteredValidations = validations.filter(function (validation) { return !validation.endDate; }) || [];
    return (_jsxs("div", __assign({ className: "flex flex-col space-y-5 xs:items-start md:items-center" }, { children: [filteredValidations.length > 0 && (_jsx("div", __assign({ className: "flex flex-row space-x-5 items-center" }, { children: filteredValidations.map(function (validation) {
                    return (_jsx(ValidationStatusTooltip, __assign({ validationId: validation.id, validationLevel: validation.validationLevel, isShowSeeDetailsText: isShowSeeDetailsText }, getState(validation)), validation.id));
                }) }), void 0)), isMobile && isShowTapText && (_jsx("p", __assign({ className: "text-grey text-12" }, { children: t('Наведите на кружок, чтобы увидеть подробности') }), void 0))] }), void 0));
};
export default ValidationStatus;
